<template>
  <span class="small font-italic text-muted mx-2">
    (Atualizado em {{ date ? $moment(date ).format(format) : '...' }} <i class="fas fa-clock" />)
  </span>
</template>
<script>
export default {
  props:{
    date:{
      type: String,
      required: true,
    },
    format:{
      type:String,
      default: "DD-MM-YYYY HH:mm",
      required: false,
    }
  }
}
</script>

<style>

</style>
